// extracted by mini-css-extract-plugin
export var container = "_4o-0";
export var icon = "_4o-1";
export var text = "_4o-2";